import React from 'react'
import useUUID from './use-uuid'
import useOperation from './use-operation'

export default function useOnOperationExecute (callback, dependencies = []) {
  const [uuid] = useUUID()
  const operation = useOperation()

  const internalCallback = (routeName, parameters = {}) => {
    if (typeof callback === 'function') {
      callback(routeName, parameters)
    }
  }

  React.useEffect(() => {
    operation.onExecute(uuid, internalCallback)

    return () => {
      operation.unsetOnExecuteCallback(uuid)
    }
  }, [operation, ...dependencies])
}
